export default class PopIn {
  constructor({ section = document }) {
    this.section = section;
    this.init();
  }

  init() {
    const popInOnScroll = (item) => {
      gsap.to(item, {
        scale: 1,
        opacity: 1,
        duration: 0.2,
        stagger: 0.2,
        scrollTrigger: {
          trigger: item,
          start: "center bottom",
        },
      });
    };
    const popInRow = (row) => {
      const items = row.children;
      gsap.to(items, {
        scale: 1,
        opacity: 1,
        duration: 0.2,
        stagger: 0.2,
        scrollTrigger: {
          trigger: row,
          start: "center bottom",
        },
      });
    };

    this.section.querySelectorAll('.pop-in').forEach((item) => {
      if (window.designMode) return;
      popInOnScroll(item);
    });
    this.section.querySelectorAll(".pop-in-row").forEach((row) => {
      if (window.designMode) return;
      popInRow(row);
    });
  }
};

